import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App.vue'

import InternationalParcelEnquiry from './components/sections/InternationalParcelEnquiry.vue'
import CollectionEnquiry from './components/sections/CollectionEnquiry.vue'
import ParcelNotCollected from './components/sections/ParcelNotCollected.vue'
import ProvideInstructions from './components/sections/ProvideInstructions.vue'
import BookCollection from './components/sections/BookCollection.vue'
import DeliveryEnquiry from './components/sections/DeliveryEnquiry.vue'
import CourierProblem from './components/sections/CourierProblem.vue'
import DeliveredTrackingPoint from './components/sections/DeliveredTrackingPoint.vue'
import CourierNoDelivery from './components/sections/CourierNoDelivery.vue'
import LastTrackingPoint from './components/sections/LastTrackingPoint.vue'
import ParcelShopProblem from './components/sections/ParcelShopProblem.vue'
import LockerProblem from './components/sections/LockerProblem.vue'
import DeliveryInstructions from './components/sections/DeliveryInstructions.vue'
import SomethingElse from './components/sections/SomethingElse.vue'
import Feedback from './components/sections/Feedback.vue'
import CouldBeBetter from './components/sections/CouldBeBetter.vue'
import WaitForExistingEnquiry from './components/sections/WaitForExistingEnquiry.vue'
import ChaseExistingEnquiryForm from './components/ChaseExistingEnquiryForm.vue'
import UpdateExistingEnquiryForm from './components/UpdateExistingEnquiryForm.vue'
import CriticalIssueForm from './components/CriticalIssueForm.vue'
import DamagedPropertyForm from './components/DamagedPropertyForm.vue'
import EscalateEnquiryForm from './components/EscalateEnquiryForm.vue'
import FeedbackForm from './components/FeedbackForm.vue'
import CancelCollection from './components/sections/CancelCollection.vue'
import DamagedParcelForm from "./components/DamagedParcelForm";
import CouldBeBetterForm from "./components/CouldBeBetterForm";

Vue.use(VueRouter)
Vue.use(Vuex)

Vue.config.devtools = true;

const store = new Vuex.Store({
  state: {
    tracking: false,
    isSubmitDisabled: false,
    override: application.override,
    businessAccount: false,
    updIncidentSolvedStatuses: ['Solved','Client: Solved'],
    businessAccountSpecific: false
  },
  mutations: {
    selectTracking(state, tracking) {
      state.tracking = tracking
    }
  },
  getters: {
    tracking: state => state.tracking
  }
});

const router = new VueRouter({
  routes: [
    { path: '/collection-enquiry', component: CollectionEnquiry,
      children: [
        { path: 'not-collected', component: ParcelNotCollected,
          children:[
            {path: 'customer-still-has-it', component: EscalateEnquiryForm},
            {path: 'no-courier', component: EscalateEnquiryForm},
            {path: 'parcel-not-taken', component: EscalateEnquiryForm}
          ]
        },
        { path: 'provide-instructions', component: ProvideInstructions, children: [
          { path: 'safe-place', component: EscalateEnquiryForm },
          { path: 'change-collection-address', component: EscalateEnquiryForm }
        ]},
        { path: 'cancel-collection', component: EscalateEnquiryForm},
        { path: 'cancel-collection-ba', component: CancelCollection, children: [
          {path: 'five-or-less', component: EscalateEnquiryForm},
          {path: 'more-than-five', component: EscalateEnquiryForm}
        ]},
        { path: 'book-collection', component: BookCollection},
        { path: 'return-not-received', component: EscalateEnquiryForm},
        { path: 'critical', component: CriticalIssueForm }
      ]
    },
    { path: '/delivery-enquiry', component: DeliveryEnquiry,
      children:[
        { path: 'courier-problem', component: CourierProblem, children: [
          { path: 'problem-signature', component: EscalateEnquiryForm },
          { path: 'delivery-location', component: EscalateEnquiryForm },
          { path: 'damaged', component: DamagedParcelForm },
          { path: 'damaged-ba', component: DamagedParcelForm }
        ]},
        { path: 'courier-no-parcel', component: DeliveredTrackingPoint},
        { path: 'courier-no-delivery', component: CourierNoDelivery, children: [
          { path: 'tracking-not-updated', component: LastTrackingPoint },
          { path: 'courier-said', component: LastTrackingPoint }
        ]},
        { path: 'parcelshop-problem', component: ParcelShopProblem, children: [
          { path: 'problem-signature', component: EscalateEnquiryForm },
          { path: 'damaged', component: DamagedParcelForm }
        ]},
        { path: 'parcelshop-no-parcel', component: DeliveredTrackingPoint},
        { path: 'parcelshop-no-delivery', component: LastTrackingPoint},
        { path: 'instructions', component: DeliveryInstructions, children: [
          { path: 'stop', component: EscalateEnquiryForm },
          { path: 'provide-access', component: EscalateEnquiryForm },
          { path: 'safe-place', component: EscalateEnquiryForm},
          { path: 'wrong-number', component: EscalateEnquiryForm}
        ]},
        { path: 'locker-problem', component: LockerProblem, children: [
          { path: 'problem-signature', component: EscalateEnquiryForm },
          { path: 'damaged', component: DamagedParcelForm }
        ]},
        { path: 'locker-no-parcel', component: DeliveredTrackingPoint},
        { path: 'locker-no-delivery', component: LastTrackingPoint},
        { path: 'instructions', component: DeliveryInstructions, children: [
          { path: 'stop', component: EscalateEnquiryForm },
          { path: 'provide-access', component: EscalateEnquiryForm },
          { path: 'safe-place', component: EscalateEnquiryForm},
          { path: 'wrong-number', component: EscalateEnquiryForm}
        ]},
        { path: 'critical', component: CriticalIssueForm }
      ]
    },
    { path: '/something-else', component: SomethingElse, children:[
      { path: 'feedback', component: Feedback, children: [
        { path: 'good-experience', component: FeedbackForm },
        { path: 'could-be-better', component: CouldBeBetter, children: [
          { path: 'behaviour', component: CouldBeBetterForm },
          { path: 'attitude', component: CouldBeBetterForm },
          { path: 'driving', component: CouldBeBetterForm },
          { path: 'harassment', component: CouldBeBetterForm },
          { path: 'something-else', component: CouldBeBetterForm }
        ]}
      ]},
      { path: 'damaged', component: DamagedPropertyForm },
      { path: 'critical', component: CriticalIssueForm }
    ]},
    { path: '/international', component: InternationalParcelEnquiry },
    { path: '/wait-for-existing-enquiry', component: WaitForExistingEnquiry },
    { path: '/chase-existing-enquiry', component: ChaseExistingEnquiryForm },
    { path: '/update-existing-enquiry', component: UpdateExistingEnquiryForm },
    { path: '/van-collection-enquiry', component: EscalateEnquiryForm },
    { path: '/order-next-day-labels', component: EscalateEnquiryForm },
    { path: '/order-assets', component: EscalateEnquiryForm },
    { path: '/priceband-enquiry', component: EscalateEnquiryForm }
  ]
})

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js